import { Routes } from '@angular/router';

export const devRoutes: Routes = [];
